import {
    ValgStateActionTypes,
    TOGGLE_UTBETALINGSPLAN,
    ToogleUtbetalingsplanAction,
    TOGGLE_VILKAR,
    ToogleFordelingAction,
    ToogleVilkarAction,
    TOGGLE_FORDELING,
    UPDATE_VALG,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederHounAppState } from '..';
import { AnyAction } from 'redux';
import { maksSkolepenger, getA, getB, getBx, getE, getD } from '../../Veileder';
import { fSkolepengerValidering } from '../../Utilities/ValideringParameters';
import { validerMinMax } from '../../../Shared/Scripts/Utilities/Validering';
import { setVisning, updateValidation } from '../Resultat/Actions';
import BSemesterValg from '../../Utilities/B-SemestertypeValg';
import AStotteValg from '../../Utilities/A-StudiestotteValg';
import ESpValg from '../../Utilities/E-SkolepengerValg';
import { ValideringsResultat } from '../../../Shared/Scripts/Models/ValideringsResultat';
import { ValgState } from '../../../VeilederOmgjoringBasisLan/Store/Valg/Types';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleUtbetalingsplan(): ToogleUtbetalingsplanAction {
    return {
        type: TOGGLE_UTBETALINGSPLAN,
    };
}

export function toggleVilkar(): ToogleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export function toggleFordeling(): ToogleFordelingAction {
    return {
        type: TOGGLE_FORDELING,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederHounAppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<VeilederHounAppState, {}, AnyAction>,
        getState: () => VeilederHounAppState,
    ): void => {
        const currentState = getState();
        const visBoksB = visB(currentState);
        const visBoksBx = visBx(currentState);
        const visBoksC = visC(currentState, visBoksB);
        const visBoksCx = visCx(currentState, visBoksB);
        const visBoksE = visE(currentState, visBoksBx, visBoksC, visBoksCx);
        const visBoksF = visF(currentState, visBoksE);
        const fValidation = isFValid(currentState, visBoksF);
        const visResultat = visRes(currentState, visBoksE, visBoksF, fValidation);
        const visFordeling = visResFordeling(currentState, visResultat);

        dispatch(updateValidation({ fValidation }));
        dispatch(
            setVisning({
                visBoksB,
                visBoksBx,
                visBoksC,
                visBoksCx,
                visBoksE,
                visBoksF,
                visFordeling,
                visResultat,
            }),
        );
    };
};

const visB = (state: VeilederHounAppState): boolean => {
    return getA(state.valg) === AStotteValg.a3_deltid;
};

const visBx = (state: VeilederHounAppState): boolean => {
    return getA(state.valg) === AStotteValg.a2_ettSemester;
};

const visC = (state: VeilederHounAppState, visBoksB: boolean): boolean => {
    return visBoksB && getB(state.valg) === BSemesterValg.b1_heltAr;
};

const visCx = (state: VeilederHounAppState, visBoksB: boolean): boolean => {
    return visBoksB && (getB(state.valg) === BSemesterValg.b2_host || getB(state.valg) === BSemesterValg.b3_var);
};

const visE = (state: VeilederHounAppState, visBoksBx: boolean, visBoksC: boolean, visBoksCx: boolean): boolean => {
    return (
        getA(state.valg) === AStotteValg.a1_heltAr ||
        (visBoksBx && getBx(state.valg) !== undefined) ||
        (visBoksC && state.valg.cSp !== undefined && isValid(state.resultat.cValidation)) ||
        (visBoksCx && state.valg.cxSp !== undefined && isValid(state.resultat.cXValidation))
    );
};

const visF = (state: VeilederHounAppState, visBoksE: boolean): boolean => {
    return visBoksE && getE(state.valg) === ESpValg.e1_ja;
};

const visRes = (
    state: VeilederHounAppState,
    visBoksE: boolean,
    visBoksF: boolean,
    fValidation: ValideringsResultat | undefined,
): boolean => {
    return (
        (visBoksE && getE(state.valg) === ESpValg.e2_nei) ||
        (visBoksF && state.valg.fSpBelop !== undefined && isValid(fValidation))
    );
};

const visResFordeling = (state: VeilederHounAppState, visResultat: boolean): boolean => {
    return visResultat && getD(state.valg) !== undefined;
};

const isFValid = (state: VeilederHounAppState, visBoksF: boolean): ValideringsResultat | undefined => {
    if (visBoksF && state.valg.fSpBelop !== undefined && state.satser != null) {
        const maxSkolepenger = maksSkolepenger(state.valg, state.resultat, state.satser);
        const valideringParameters = fSkolepengerValidering(maxSkolepenger, state.epiContext.locale);
        const validering = validerMinMax(state.epiContext, state.valg.fSpBelop, valideringParameters);
        return validering;
    }
    return undefined;
};

const isValid = (resultat: ValideringsResultat | undefined): boolean => {
    return resultat !== undefined && resultat.isValid;
};
